"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionsTypesMapping = exports.ResourceType = exports.Registration = exports.Status = exports.State = exports.INSTANT_WIN = exports.TEAM_CHALLENGE = exports.CHARITY = exports.RACE = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _types = require("./types");

var _actionsTypesMapping;

var RACE = 'race';
exports.RACE = RACE;
var CHARITY = 'charity';
exports.CHARITY = CHARITY;
var TEAM_CHALLENGE = 'teamChallenge';
exports.TEAM_CHALLENGE = TEAM_CHALLENGE;
var INSTANT_WIN = 'instantWin';
exports.INSTANT_WIN = INSTANT_WIN;
var State;
exports.State = State;

(function (State) {
  State["UNKNOWN"] = "unknown";
  State["NOT_STARTED_NOT_REGISTERED"] = "not_started_not_registered";
  State["NOT_STARTED_REGISTERED"] = "not_started_registered";
  State["STARTED_NOT_REGISTERED"] = "started_not_registered";
  State["STARTED_REGISTERED"] = "started_registered";
  State["STARTED_FINISHER"] = "started_finisher";
  State["FINISHED_NOT_REGISTERED"] = "finished_not_registered";
  State["FINISHED_NOT_FINISHER"] = "finished_not_finisher";
  State["FINISHED_FINISHER"] = "finished_finisher";
  State["ON_GOING"] = "ON_GOING";
  State["SUCCESS"] = "SUCCESS";
  State["FINISH"] = "FINISH";
  State["WAITING"] = "WAITING";
})(State || (exports.State = State = {}));

var Status;
exports.Status = Status;

(function (Status) {
  Status["UNKNOWN"] = "unknown";
  Status["CURRENT"] = "current";
  Status["PAST"] = "past";
  Status["FUTURE"] = "future";
})(Status || (exports.Status = Status = {}));

var Registration;
exports.Registration = Registration;

(function (Registration) {
  Registration["CODE"] = "code";
  Registration["PAID"] = "paying";
})(Registration || (exports.Registration = Registration = {}));

var ResourceType;
exports.ResourceType = ResourceType;

(function (ResourceType) {
  ResourceType["CHALLENGE"] = "challenge";
  ResourceType["GROUPE"] = "group";
})(ResourceType || (exports.ResourceType = ResourceType = {}));

var actionsTypesMapping = (_actionsTypesMapping = {}, (0, _defineProperty2["default"])(_actionsTypesMapping, _types.UserActionsType.FEED_MESSAGE, "ds-challenges.objective.".concat(_types.UserActionsType.FEED_MESSAGE)), (0, _defineProperty2["default"])(_actionsTypesMapping, _types.UserActionsType.FEED_ACTIVITY_SHARE, "ds-challenges.objective.".concat(_types.UserActionsType.FEED_ACTIVITY_SHARE)), (0, _defineProperty2["default"])(_actionsTypesMapping, _types.UserActionsType.REFERRAL_SUCCESS, "ds-challenges.objective.".concat(_types.UserActionsType.REFERRAL_SUCCESS)), (0, _defineProperty2["default"])(_actionsTypesMapping, _types.UserActionsType.CHALLENGE_SUCCESS, "ds-challenges.objective.".concat(_types.UserActionsType.CHALLENGE_SUCCESS)), (0, _defineProperty2["default"])(_actionsTypesMapping, _types.UserActionsType.BONUS_APPLIED, "ds-challenges.objective.".concat(_types.UserActionsType.BONUS_APPLIED)), _actionsTypesMapping);
exports.actionsTypesMapping = actionsTypesMapping;
//# sourceMappingURL=constants.js.map